import React from "react";
import { ReportField } from "./ReportField";
import { Box } from "@mui/material";
interface InsuranceSummaryContainerProps {
  userId: string;
  propertyId: string;
}

export const InsuranceSummaryContainer: React.FC<
  InsuranceSummaryContainerProps
> = ({ userId, propertyId }) => {
  return (
    <Box sx={{ pl: 6 }}>
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Insurance Provider"
        fieldKey="insuranceSummary.provider"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Coverage Summary"
        fieldKey="insuranceSummary.coverageSummary"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Owner Insurance Required"
        fieldKey="insuranceSummary.ownerInsuranceRequired"
      />
      <ReportField
        userId={userId}
        propertyId={propertyId}
        title="Deductible"
        fieldKey="insuranceSummary.deductible"
      />
    </Box>
  );
};
